import * as React from 'react';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';
import clsx from 'clsx';
import BlurText from '../BlurText';
import truncateString from '@th/shared/src/utils/truncateString';
import SvgIcon from '../icons/SvgIcon';

type Props = {
  listing: SimpleListing;
  includeSoldDate?: boolean;
  className?: string;
  isBlurred?: boolean;
};

export default function ListingCardStatusText({
  listing,
  includeSoldDate,
  className,
  isBlurred = false,
}: Props) {
  const color = listing.lastStatusColor();
  return (
    <div
      className={clsx(
        'flex flex-1 flex-row items-center justify-start ',
        className,
      )}
    >
      <div className="flex flex-row items-center">
        <SvgIcon name={'GoDotFill'} style={{ color }} />
        <p className="ml-1.5" style={{ color }}>
          {truncateString(listing.lastStatusText(), 16)}
        </p>
      </div>
      {includeSoldDate && listing.soldDateText() ? (
        <>
          <p className="mx-2">|</p>
          <BlurText isBlurred={isBlurred}>
            {listing.soldDateText() || ''}
          </BlurText>
        </>
      ) : null}
      <>
        <p className="mx-2">|</p>
        <BlurText isBlurred={isBlurred}>{listing.daysOnMarketText()}</BlurText>
      </>
    </div>
  );
}
